<script lang="ts" setup>
	import { cn } from '@/helpers/cn'

	interface Props {
		class?: string
	}

	const props = defineProps<Props>()
</script>

<template>
	<tr :class="cn('border-t border-gray-200 hover:bg-gray-50', props.class)">
		<slot />
	</tr>
</template>
